<template>
  <section class="topic-article-list">
    <template v-if="hasChild">
      <topic-tabs @change-slide="toChangeSlide"></topic-tabs>
      <div class="topic-article-list-inner">
        <!-- <Swiper @swiper="onListSwiper" @slide-change="onListSlideChange">
          <SwiperSlide v-for="item in topicChannels" :key="item.id">
            <topic-article-slide
              v-if="topicGroupNews[item.id] && topicGroupNews[item.id].length"
              :news-list="topicGroupNews[item.id]"
            ></topic-article-slide>
          </SwiperSlide>
        </Swiper> -->
        <topic-article-slide
          v-if="hasChildArticleList && hasChildArticleList.length"
          :news-list="hasChildArticleList"
        ></topic-article-slide>
      </div>
    </template>
    <template v-else>
      <div class="topic-article-list-no-child">
        <div class="asc-desc-group">
          <div
            class="asc-btn"
            :class="{ 'asc-desc-active': articleSort === 'desc' }"
            @click="articleSort = 'desc'"
          >
            <div class="desc-btn-icon"></div>
            倒序
          </div>
          <div
            class="desc-btn"
            :class="{ 'asc-desc-active': articleSort === 'asc' }"
            @click="articleSort = 'asc'"
          >
            <div class="asc-btn-icon"></div>
            正序
          </div>
        </div>
        <topic-article
          v-for="article in noChildArticleList"
          :key="article.id"
          :article="article"
        >
        </topic-article>
        <bottom-tips></bottom-tips>
      </div>
    </template>
  </section>
</template>

<script setup lang="ts">
import { fetchGroupJson, fetchTopicJson } from '../apis/api';
import 'swiper/css';
import 'animate.css';

defineOptions({
  name: 'TopicArticleList',
});
const props = withDefaults(
  defineProps<{
    hasChild: boolean;
    topicParams: {
      year: string;
      month: string;
      date: string;
      topicId: string;
    };
  }>(),
  {},
);

const topicChannels =
  inject<Ref<{ id: string; name: string; topicId: string }[]>>('topicChannels');
const currentPageObj: { [key: string]: number } = {};
const topicGroupNews = reactive<{ [key: string]: Topic.Article[] }>({});
const articleSort = ref<'asc' | 'desc'>('desc');

const noChildArticleList = computed(() => {
  if (!topicGroupNews[props.topicParams.topicId]) {
    return [];
  }
  const tempList = [...topicGroupNews[props.topicParams.topicId]];
  if (articleSort.value === 'desc') {
    return tempList;
  }
  tempList.reverse();
  return tempList;
});
const currentChannelIndex = ref(0);

const hasChildArticleList = computed(() => {
  const { id } = topicChannels?.value[currentChannelIndex.value] || {};
  if (id) {
    return topicGroupNews[id];
  }
  return [];
});

const toChangeSlide = (index: number) => {
  currentChannelIndex.value = index;
};
provide('currentChannelIndex', currentChannelIndex);

const formatDataList = (groupId: string, list: RMT.News[]) => {
  if (!topicGroupNews[groupId]) {
    topicGroupNews[groupId] = [];
  }
  topicGroupNews[groupId] = [
    ...topicGroupNews[groupId],
    ...list.map((item) => {
      let tempImageList = [item.data.mCoverImg];
      if (item.data.mCoverImg1) {
        tempImageList = [item.data.mCoverImg1];
      }
      return {
        id: item.data.id,
        contentType: item.data.contentType,
        mListpattern: item.data.mListpattern,
        createtime: item.data.createtime,
        moVideoOsspath: item.data.moVideoOsspath,
        publishTime: item.data.publishTime,
        shorttitle: item.data.shorttitle,
        url: item.data.url,
        moVideoPath: item.data.moVideoPath,
        title: item.data.title,
        description: item.data.description,
        mCoverImgList: tempImageList,
        timeAxisStr: item.data.timeAxisStr,
        isShowTimeLink: Number(item.data.isShowTimeLink),
      };
    }),
  ];
};

const getGroupNews = (groupId: string) => {
  const { year, month, date, topicId } = props.topicParams;
  fetchGroupJson(
    year,
    month,
    date,
    topicId,
    groupId,
    currentPageObj[groupId],
  ).then((res) => {
    formatDataList(groupId, res.dataList);
    if (res.hasNext) {
      currentPageObj[groupId] += 1;
      getGroupNews(groupId);
    }
  });
};

const getTopicNews = () => {
  const { year, month, date, topicId } = props.topicParams;
  fetchTopicJson(year, month, date, topicId).then((res) => {
    if (res.dataList && res.dataList.length) {
      formatDataList(topicId, res.dataList);
    }
    if (res.hasNext) {
      currentPageObj[topicId] += 1;
      getGroupNews(topicId);
    }
  });
};

onMounted(() => {
  topicChannels?.value.forEach((item) => {
    currentPageObj[item.id] = 1;
    if (props.hasChild) {
      getGroupNews(item.id);
    }
  });
  if (!props.hasChild) {
    currentPageObj[props.topicParams.topicId] = 1;
    getTopicNews();
  }
});
</script>
<style lang="scss" scoped>
.topic-article-list {
  .topic-article-list-inner {
    padding-top: 5px;
  }

  .topic-article-list-no-child {
    padding-top: 15px;
  }

  :deep(.asc-desc-group) {
    display: flex;
    align-items: center;
    margin: 0 15px 10px;

    .asc-btn,
    .desc-btn {
      display: flex;
      gap: 2px;
      align-items: center;
      justify-content: center;
      width: 70px;
      height: 24px;
      font-size: 0.75rem;
      cursor: pointer;
      border: 1px solid #000;
      opacity: 0.2;
    }

    .asc-btn-icon,
    .desc-btn-icon {
      width: 12px;
      height: 11px;
      background-size: 100% 100%;
    }

    .asc-btn-icon {
      background-image: var(--asc-icon-background);
    }

    .desc-btn-icon {
      background-image: var(--desc-icon-background);
    }

    .asc-desc-active {
      color: var(--asc-desc-active-color);
      border: 1px solid rgb(0 0 0 / 20%);
      opacity: 1;
    }

    .asc-btn {
      border-right-style: none;
      border-radius: 4px 0 0 4px;
    }

    .desc-btn {
      border-radius: 0 4px 4px 0;
    }
  }
}
</style>
